import { Injectable } from '@angular/core';
import { VendorFlagsPercentages } from '../models/percentages-response.model';

@Injectable({
  providedIn: 'root',
})
export class RiskScoreService {
  constructor() {}

  greydOutColor = { color: '#969696', colorName: 'gray' };

  colorMap = [
    { color: '#388E3C', max: 6000, colorName: 'green' },
    { color: '#FBC02D', max: 14000, colorName: 'yellow' },
    { color: '#D32F2F', max: 20000, colorName: 'red' },
  ];

  calculatePercentageColor(perc: VendorFlagsPercentages): {
    color: string;
    colorName: string;
  } {
    const total = perc.high + perc.medium + perc.low;
    if (total === 0) {
      return this.greydOutColor;
    }

    //find wich percentage is the highest
    const maxPerc = Math.max(perc.high, perc.medium, perc.low);

    if (maxPerc === perc.high) {
      return this.colorMap[2]; // red
    } else if (maxPerc === perc.medium) {
      return this.colorMap[1]; // yellow
    } else {
      return this.colorMap[0]; // green
    }
  }

  sumPercentages(percentages: VendorFlagsPercentages[]) {
    let percentageSum: VendorFlagsPercentages = {
      high: 0,
      medium: 0,
      low: 0,
    };
    percentages.forEach((percentage) => {
      percentageSum.high += percentage.high;
      percentageSum.medium += percentage.medium;
      percentageSum.low += percentage.low;
    });

    percentageSum.high = Math.round(percentageSum.high / percentages.length);
    percentageSum.medium = Math.round(
      percentageSum.medium / percentages.length,
    );
    percentageSum.low = Math.round(percentageSum.low / percentages.length);

    return percentageSum;
  }
}
